"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isKeyPressed = void 0;
var utils_1 = require("../types/utils");
/**
 * This is the function that returns a boolean value, the goal is to check if a keyPress event corresponds to
 * the key you are checking for based on the keyCode.
 */
var isKeyPressed = function (_a) {
    var event = _a.event, key = _a.key;
    return event.keyCode === utils_1.KeyCodeList[key];
};
exports.isKeyPressed = isKeyPressed;
//# sourceMappingURL=isKeyPressed.js.map